import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const AuthContext = createContext();

// Created a provider component
 export const AuthProvider = ({ children }) => {
  const [authDetails, setAuthDetails] = useState(() => {
    // Try to get the initial state from localStorage
    const savedAuthDetails = localStorage.getItem('authDetails');
    return savedAuthDetails ? JSON.parse(savedAuthDetails) : null;
  });

  useEffect(() => {
    // Store auth details in localStorage whenever they change
    if (authDetails) {
      localStorage.setItem('authDetails', JSON.stringify(authDetails));
    } else {
      localStorage.removeItem('authDetails');
    }
  }, [authDetails]);

  return (
    <AuthContext.Provider value={{ authDetails, setAuthDetails }}>
      {children}
    </AuthContext.Provider>
  );
};